<template>
  <div
    id="preinshistory"
    class="modal fade show custom-modal"
    role="dialog"
    data-backdrop="static"
    data-keyboard="false"
    :class="{'modal-show':showPinHistory}"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content round-corner">
        <div class="mx-4 d-flex modal-head">
          <h4 class="mb-0">Motor Pre-Inspection History</h4>
          <button class="close text-right" @click="closeModal()" data-dismiss="modal">&times;</button>
        </div>
        <div class="mx-3 px-2 py-2 pb-5 modal-body">
          <table class="custom-table w-80 table" :class="{'hide-table': getPinHistoryResponse.length===0}">
            <tr>
              <th class="pre-inspection-history font-weight-bold">PIN Number</th>
              <th class="pre-inspection-history font-weight-bold">Status</th>
              <th class="pre-inspection-history font-weight-bold">User ID</th>
              <th class="pre-inspection-history font-weight-bold">Record Date</th>
              <th class="pre-inspection-history font-weight-bold">Record Time</th>
              <th class="pre-inspection-history font-weight-bold">Recorded By</th>
              <th class="pre-inspection-history font-weight-bold">User's Remarks</th>
              <th class="pre-inspection-history font-weight-bold">Approver's Comment</th>
            </tr>
            <tr v-for="(pinHistoryResponse,index) in getPinHistoryResponse" :key="index">
              <td class>
                <span class="mobile-label">PIN Number</span>
                <span>
                  <small>{{historyPin}}</small>
                </span>
              </td>
              <td class>
                <span class="mobile-label">Status</span>
                <span>
                  <small>{{pinHistoryResponse.status}}</small>
                </span>
              </td>
              <td class>
                <span class="mobile-label">User ID</span>
                <span>
                  <small>{{pinHistoryResponse.userId}}</small>
                </span>
              </td>
              <td class>
                <span class="mobile-label">Record Date</span>
                <span>
                  <small>{{pinHistoryResponse.recordDate}}</small>
                </span>
              </td>
              <td class>
                <span class="mobile-label">Record Time</span>
                <span>
                  <small>{{pinHistoryResponse.recordTime}}</small>
                </span>
              </td>
              <td class>
                <span class="mobile-label">Recorded By</span>
                <span>
                  <small>{{pinHistoryResponse.recordBy}}</small>
                </span>
              </td>
              <td class>
                <span class="mobile-label">User's Remarks</span>
                <span>
                  <small>{{pinHistoryResponse.usersRemarks}}</small>
                </span>
              </td>
              <td class>
                <span class="mobile-label">Approver's Comment</span>
                <span>
                  <small>{{pinHistoryResponse.approversComment}}</small>
                </span>
              </td>
            </tr>
          </table>
          <span v-if="getPinHistoryResponse.length===0">No Detail Found</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PreInspectionHistoryModal",
  props: ["getPinHistoryResponse", "historyPin", "showPinHistory"],
  setup(props, { emit }){
    function closeModal () {
        emit("close");
    }
    return {
      closeModal
    }
  },
};
</script>
<style scoped>
.hide-table {
  display: none;
}
.modal-head {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  margin: 28px 5px 17px 5px;
  justify-content: space-between;
}
.round-corner {
  border-radius: 10px;
}
.custom-table th,
.modal-head h4 {
  color: #0070be;
}
.btn-custom {
  background: #f0a008;
}
.custom-table tr:nth-child(2n + 3) {
  background-color: #d3d3d3;
}
.custom-table th:nth-child(1) {
  width: 12%;
}
.custom-table th:nth-child(2) {
  width: 16%;
}
.custom-table th:nth-child(3) {
  width: 9%;
}
.custom-table th:nth-child(4) {
  width: 11%;
}
.custom-table th:nth-child(5) {
  width: 10%;
}
.custom-table th:nth-child(6) {
  width: 11%;
}
.custom-table th:nth-child(7) {
  width: 13%;
}
.outline-none {
  outline: none;
}
.modal-lg {
  max-width: 1073px;
}
.mobile-label {
  display: none;
}
@media (max-width: 767px) {
  .mobile-label {
    font-size: 14px;
    width: 100%;
    display: inline-block;
    color: #0070be;
    font-weight: bold;
  }
  .pre-inspection-history {
    display: none;
  }
  .table td {
    border-top: none;
    width: 25%;
    display: inline-block;
  }
}
@media (max-width: 450px) {
  .mobile-label {
    font-size: 14px;
    width: 100%;
    display: inline-block;
    color: #0070be;
    font-weight: bold;
  }
  .pre-inspection-history {
    display: none;
  }
  .table td {
    border-top: none;
    width: 26%;
    display: inline-block;
  }
}
</style>